<router-outlet />
<p-toast [motionOptions]="{ duration: 500 }" />
